import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Crown, Monitor, ShieldCheck } from 'lucide-react';
export function Nightlife() {
  const features = [{
    icon: Crown,
    title: 'VIP',
    subtitle: 'Bottle Service'
  }, {
    icon: Monitor,
    title: '190FT',
    subtitle: 'Video Wall'
  }, {
    icon: ShieldCheck,
    title: '21+',
    subtitle: 'Dress Code'
  }];
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-1047">
      <Header data-id="element-1048" />

      {/* Hero Section */}
      <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-1049">
        {/* Background */}
        <div className="absolute inset-0 z-0" data-id="element-1050">
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B1014] via-[#0B1014]/50 to-[#0B1014] z-10" data-id="element-1051" />
          <img src="https://images.unsplash.com/photo-1566737236500-c8ac43014a67?q=80&w=2070&auto=format&fit=crop" alt="Nightlife" className="w-full h-full object-cover opacity-50" data-id="element-1052" />
        </div>

        {/* Content */}
        <div className="relative z-20 text-center px-4 max-w-5xl mx-auto" data-id="element-1053">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1054">
            <div className="inline-block mb-6" data-id="element-1055">
              <span className="text-[#DDA247] text-sm font-bold uppercase tracking-[0.3em] border border-[#DDA247] px-6 py-2" data-id="element-1056">
                11PM - 3AM
              </span>
            </div>
            <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold mb-12 tracking-tight" data-id="element-1057">
              NIGHTLIFE
            </h1>

            <Link to="/bottle-service" data-id="element-1058">
              <Button size="lg" className="min-w-[200px]" data-id="element-1059">
                RESERVE VIP TABLE
              </Button>
            </Link>
          </motion.div>
        </div>

        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 1
      }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20" data-id="element-1060">
          <div className="w-[1px] h-24 bg-gradient-to-b from-transparent via-[#DDA247] to-transparent animate-pulse" data-id="element-1061" />
        </motion.div>
      </section>

      {/* Content Section */}
      <section className="py-24 px-4 md:px-8 bg-[#0B1014]" data-id="element-1062">
        <div className="max-w-7xl mx-auto" data-id="element-1063">
          <div className="text-center mb-20" data-id="element-1064">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-1065">
              Where celebrities, athletes, and entertainers come to celebrate.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1066">
            {features.map((feature, index) => <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.6
          }} className="bg-[#11161A] border border-white/10 p-10 text-center group hover:border-[#DDA247] transition-colors duration-300" data-id="element-1067">
                <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-[#DDA247]/10 rounded-full group-hover:bg-[#DDA247]/20 transition-colors duration-300" data-id="element-1068">
                  <feature.icon className="w-10 h-10 text-[#DDA247]" data-id="element-1069" />
                </div>
                <h3 className="text-3xl font-bold text-[#DDA247] mb-2 tracking-wide" data-id="element-1070">
                  {feature.title}
                </h3>
                <p className="text-gray-400 text-lg tracking-wide" data-id="element-1071">
                  {feature.subtitle}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-1072" />
    </div>;
}